<div class="page" [class.inline]="inline">
  <div class="card">
    <div class="card-header">
      <div>
        <h1>{{ 'actualite.filActualite.header.title' | translate }}</h1>
        <p class="subtitle">{{ 'actualite.filActualite.header.subtitle' | translate }}</p>
      </div>
    </div>

    <div class="page-layout">
      <div class="composer-column">
        <div class="nouveau-message">
          <div class="composer-header">
            <h3>{{ 'actualite.filActualite.composer.title' | translate }}</h3>
          </div>
          <!-- Sélection des sites (multi-site uniquement, masqué en inline) -->
          <div class="site-selector" *ngIf="hasMultipleSites() && !inline">
            <div class="site-dropdown-wrap">
              <button type="button" class="site-trigger" (click)="showSiteDropdown = !showSiteDropdown">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                {{ selectedSiteLabel() }}
                <svg class="chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>
              </button>

              <div class="site-dropdown" *ngIf="showSiteDropdown">
                <label class="site-option site-option-all">
                  <input type="checkbox" [checked]="isAllSitesSelected()" (change)="toggleAllSites()">
                  <span class="site-option-name">{{ 'actualite.filActualite.siteSelector.allSites' | translate }}</span>
                  <span class="site-count">({{ allEstablishments().length }})</span>
                </label>
                <div class="site-divider"></div>
                <label class="site-option" *ngFor="let e of allEstablishments()">
                  <input type="checkbox" [checked]="isSiteSelected(e.id)" (change)="toggleSite(e.id)">
                  <span class="site-option-name">{{ e.name }}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group titre-lang">
            <img *ngIf="hasMultipleLanguages()" [src]="flagIcon('fr')" alt="FR" class="lang-badge">
            <input
              type="text"
              [ngModel]="nouveauTitre()"
              (ngModelChange)="nouveauTitre.set($event)"
              [placeholder]="'actualite.filActualite.composer.titlePlaceholder' | translate"
              class="input-titre"
              maxlength="100">
          </div>
          <div class="form-group">
            <input
              type="text"
              list="categorieOptions"
              [ngModel]="nouvelleCategorie()"
              (ngModelChange)="nouvelleCategorie.set($event)"
              [placeholder]="'actualite.filActualite.composer.categoryPlaceholder' | translate"
              class="input-titre input-categorie"
              maxlength="50">
            <datalist id="categorieOptions">
              <option value="Prévention">{{ 'actualite.filActualite.composer.categoryOptions.prevention' | translate }}</option>
              <option value="Information">{{ 'actualite.filActualite.composer.categoryOptions.information' | translate }}</option>
              <option value="Travaux">{{ 'actualite.filActualite.composer.categoryOptions.works' | translate }}</option>
              <option value="Fermeture exceptionnelle">{{ 'actualite.filActualite.composer.categoryOptions.exceptionalClosure' | translate }}</option>
            </datalist>
          </div>
          <div *ngFor="let lang of additionalLanguages()" class="form-group titre-lang titre-lang-ar" [class.lang-rtl]="isRtl(lang)">
            <img [src]="flagIcon(lang)" [alt]="lang | uppercase" class="lang-badge">
            <input
              type="text"
              [ngModel]="nouveauTitreByLang()[lang] || ''"
              (ngModelChange)="setNouveauTitreLang(lang, $event)"
              [placeholder]="'actualite.filActualite.composer.titlePlaceholderLang' | translate: { lang: lang.toUpperCase() }"
              class="input-titre input-ar"
              [class.lang-rtl]="isRtl(lang)"
              maxlength="100"
              [attr.dir]="isRtl(lang) ? 'rtl' : null">
          </div>
          <div class="form-group message-lang">
            <img *ngIf="hasMultipleLanguages()" [src]="flagIcon('fr')" alt="FR" class="lang-badge">
            <div class="textarea-container">
              <textarea
                [ngModel]="nouveauMessage()"
                (ngModelChange)="nouveauMessage.set($event)"
                [placeholder]="'actualite.filActualite.composer.messagePlaceholder' | translate"
                class="textarea-message"
                maxlength="1000"
                rows="6"></textarea>
              <button type="button" class="btn-emoji" (click)="showEmojiPicker = !showEmojiPicker">😊</button>
              <div class="char-count">{{ nouveauMessage().length }}/1000</div>

              <emoji-mart *ngIf="showEmojiPicker"
                          class="emoji-picker"
                          (emojiSelect)="addEmoji($event)"
                          [darkMode]="false">
              </emoji-mart>
            </div>
          </div>
          <div *ngFor="let lang of additionalLanguages()" class="form-group message-lang message-lang-ar" [class.lang-rtl]="isRtl(lang)">
            <img [src]="flagIcon(lang)" [alt]="lang | uppercase" class="lang-badge">
            <div class="textarea-container">
              <textarea
                [ngModel]="nouveauMessageByLang()[lang] || ''"
                (ngModelChange)="setNouveauMessageLang(lang, $event)"
                [placeholder]="'actualite.filActualite.composer.messagePlaceholderLang' | translate: { lang: lang.toUpperCase() }"
                class="textarea-message input-ar"
                [class.lang-rtl]="isRtl(lang)"
                maxlength="1000"
                rows="6"
                [attr.dir]="isRtl(lang) ? 'rtl' : null"></textarea>
              <button type="button" class="btn-emoji" (click)="toggleEmojiPickerLang(lang)">😊</button>
              <div class="char-count">{{ (nouveauMessageByLang()[lang] || '').length }}/1000</div>

              <emoji-mart *ngIf="openEmojiPickerLang === lang"
                          class="emoji-picker"
                          (emojiSelect)="addEmojiLang(lang, $event)"
                          [darkMode]="false">
              </emoji-mart>
            </div>
          </div>
          <div class="form-group">
            <label class="file-label">
              <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" (change)="onImageSelect($event)" class="file-input" />
              <span class="file-button">📎 {{ 'actualite.filActualite.composer.addImage' | translate }}</span>
            </label>
            <div *ngIf="selectedImage" class="file-info">
              <span class="file-name">📄 {{ selectedImage.name }}</span>
              <button type="button" class="btn-remove-file" (click)="removeImage()">✕</button>
            </div>
          </div>
          <button
            class="btn-publier"
            (click)="publierMessage()"
            [disabled]="!canPublish()">
            {{ 'actualite.filActualite.composer.publish' | translate }}
          </button>
        </div>
      </div>

      <div class="messages-column">
        <div *ngIf="loading()" class="state">{{ 'actualite.filActualite.states.loading' | translate }}</div>
        <div *ngIf="!loading() && error()" class="state error">{{ error() }}</div>
        <div *ngIf="!loading() && !error() && messages().length === 0" class="state">{{ 'actualite.filActualite.states.empty' | translate }}</div>
        
        <div *ngIf="!loading() && !error() && messages().length > 0" class="messages-list">
          <div *ngFor="let message of messages()" class="message-item">
            <div class="message-header">
              <div class="header-ligne-2">
                <span class="auteur-nom">{{ message.auteur }}</span>
                <span class="separator">·</span>
                <span class="message-time">{{ getTimeAgo(message.createdAt) }}</span>
                <span class="separator" *ngIf="hasMultipleSites() && getSitesLabel(message)">·</span>
                <span class="message-sites" *ngIf="hasMultipleSites() && getSitesLabel(message)">({{ getSitesLabel(message) }})</span>
                <button
                  *ngIf="message.canDelete"
                  class="btn-supprimer-header"
                  (click)="supprimerMessage(message.id)"
                  [title]="'actualite.filActualite.message.deleteTitle' | translate">
                  <img src="assets/delete.svg" [attr.alt]="'actualite.filActualite.message.deleteAlt' | translate" class="icon-delete" />
                </button>
                <button
                  *ngIf="message.canDelete"
                  class="btn-modifier-header"
                  (click)="startEditMessage(message)"
                  [title]="'actualite.filActualite.message.editTitle' | translate">
                  <img src="assets/modification.svg" [attr.alt]="'actualite.filActualite.message.editAlt' | translate" class="icon-edit" />
                </button>
              </div>
              <div class="header-ligne-1">
                <div class="message-titres">
                  <div class="titre-lang" [class.titre-lang-solo]="!hasMultipleLanguages()">
                    <img *ngIf="hasMultipleLanguages()" [src]="flagIcon('fr')" alt="FR" class="lang-badge">
                    <h4 class="message-titre">{{ message.titre }}</h4>
                    @if (message.categorie) {
                      <span class="badge-categorie">{{ message.categorie }}</span>
                    }
                  </div>
                  <div *ngFor="let lang of additionalLanguages()" class="titre-lang titre-lang-ar" [class.lang-rtl]="isRtl(lang)">
                    <img [src]="flagIcon(lang)" [alt]="lang | uppercase" class="lang-badge">
                    <h4 class="message-titre" [attr.dir]="isRtl(lang) ? 'rtl' : null">{{ getLocalizedText(message.titre, message.titreI18n, lang) }}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="message-content">
              <div *ngIf="editingMessageId() === message.id; else displayMessage" class="edit-form">
                <input type="text" [(ngModel)]="editTitre" class="edit-titre" [placeholder]="'actualite.filActualite.message.editTitlePlaceholder' | translate" />
                <input type="text" list="categorieOptions" [(ngModel)]="editCategorie" class="edit-titre input-categorie" [placeholder]="'actualite.filActualite.message.editCategoryPlaceholder' | translate" maxlength="50" />
                <div *ngFor="let lang of additionalLanguages()" class="edit-lang-field" [class.lang-rtl]="isRtl(lang)">
                  <img [src]="flagIcon(lang)" [alt]="lang | uppercase" class="lang-badge">
                  <input type="text" [(ngModel)]="editTitreByLang[lang]" class="edit-titre input-ar" [class.lang-rtl]="isRtl(lang)" [placeholder]="'actualite.filActualite.message.editTitlePlaceholderLang' | translate: { lang: lang.toUpperCase() }" [attr.dir]="isRtl(lang) ? 'rtl' : null" />
                </div>
                <textarea [(ngModel)]="editContenu" class="edit-contenu" rows="4" [placeholder]="'actualite.filActualite.message.editMessagePlaceholder' | translate"></textarea>
                <div *ngFor="let lang of additionalLanguages()" class="edit-lang-field" [class.lang-rtl]="isRtl(lang)">
                  <img [src]="flagIcon(lang)" [alt]="lang | uppercase" class="lang-badge">
                  <textarea [(ngModel)]="editContenuByLang[lang]" class="edit-contenu input-ar" [class.lang-rtl]="isRtl(lang)" rows="4" [placeholder]="'actualite.filActualite.message.editMessagePlaceholderLang' | translate: { lang: lang.toUpperCase() }" [attr.dir]="isRtl(lang) ? 'rtl' : null"></textarea>
                </div>
                <label class="file-label">
                  <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" (change)="onEditImageSelect($event)" class="file-input" />
                  <span class="file-button-small">📎 {{ 'actualite.filActualite.message.editImage' | translate }}</span>
                </label>
                <div *ngIf="editImage" class="file-info-small">
                  <span class="file-name">📄 {{ editImage.name }}</span>
                  <button type="button" class="btn-remove-file-small" (click)="removeEditImage()">✕</button>
                </div>
                <div class="edit-actions">
                  <button class="btn-cancel-edit" (click)="cancelEditMessage()">{{ 'actualite.filActualite.message.cancel' | translate }}</button>
                  <button class="btn-save-edit" (click)="saveEditMessage(message.id)">{{ 'actualite.filActualite.message.save' | translate }}</button>
                </div>
              </div>
              <ng-template #displayMessage>
                <div class="message-lang" [class.message-lang-solo]="!hasMultipleLanguages()">
                  <img *ngIf="hasMultipleLanguages()" [src]="flagIcon('fr')" alt="FR" class="lang-badge">
                  <p class="message-texte">{{ message.description }}</p>
                </div>
                <div *ngFor="let lang of additionalLanguages()" class="message-lang message-lang-ar" [class.lang-rtl]="isRtl(lang)">
                  <img [src]="flagIcon(lang)" [alt]="lang | uppercase" class="lang-badge">
                  <p class="message-texte" [attr.dir]="isRtl(lang) ? 'rtl' : null">{{ getLocalizedText(message.description, message.descriptionI18n, lang) }}</p>
                </div>
                <div *ngIf="message.imageContentType && getImageUrl(message.id) as imgUrl" class="message-image">
                  <img *ngIf="message.imageContentType !== 'application/pdf'" [src]="imgUrl" [attr.alt]="'actualite.filActualite.message.imageAlt' | translate" />
                  <embed *ngIf="message.imageContentType === 'application/pdf'" [src]="imgUrl" type="application/pdf" />
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-confirm-modal
  *ngIf="showConfirmModal()"
  [title]="confirmModalTitle()"
  [message]="confirmModalMessage()"
  [confirmText]="'actualite.filActualite.confirm.confirmText' | translate"
  [cancelText]="'actualite.filActualite.confirm.cancelText' | translate"
  (confirm)="onConfirmAction()"
  (cancel)="onCancelAction()">
</app-confirm-modal>
